import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserSettingsDrawerService {
  private isUserSettingsShownSource: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public isUserSettingsShown$: Observable<boolean> =
    this.isUserSettingsShownSource.asObservable();

  public show(): void {
    this.isUserSettingsShownSource.next(true);
  }

  public hide(): void {
    this.isUserSettingsShownSource.next(false);
  }

  public toggle(): void {
    this.isUserSettingsShownSource.next(
      !this.isUserSettingsShownSource.getValue(),
    );
  }
}
